import ScheduleTable from "./ScheduleTable";
import PastEventsTable from "./PastEventsTable";
import useDashboardEvents from "../_hooks/useDashboardEvents";
import useIsDashboardSingleColumn from "../_hooks/useIsDashboardSingleColumn";
import { getDashboardPanelStackClassName } from "../_utils/dashboardLayoutClasses";

export default function DashboardEventsPanels() {
  const isSingleColumnLayout = useIsDashboardSingleColumn();
  const {
    canViewEvents,
    sectionScopeReady,
    hasSectionScope,
    scopedSectionNames,
    scheduleByMonth,
    pastEvents,
    scheduleLoading,
    pastLoading,
    scheduleError,
    pastError
  } = useDashboardEvents();

  if (!canViewEvents) {
    return null;
  }

  const missingSectionScope = sectionScopeReady && !hasSectionScope;

  return (
    <div className={getDashboardPanelStackClassName(isSingleColumnLayout)} data-testid="home-dashboard-events-panels">
      <ScheduleTable
        eventsLink="/events"
        scheduleByMonth={scheduleByMonth}
        scopedSectionNames={scopedSectionNames}
        loading={scheduleLoading}
        error={scheduleError}
        missingSectionScope={missingSectionScope}
      />
      <PastEventsTable
        pastEvents={pastEvents}
        scopedSectionNames={scopedSectionNames}
        loading={pastLoading}
        error={pastError}
        missingSectionScope={missingSectionScope}
      />
    </div>
  );
}
